var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nobox"},[_c('div',{staticClass:"block-title"},[_vm._v("充电费用")]),_c('div',{ref:"echartDiv",staticStyle:{"height":"260px","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }